import React, { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import PropTypes from 'prop-types';
import { TableControls } from '../../../../BaseEditor';

function Row({
  row, fields, actions, readOnly, active, errors, currentOrg,
}) {
  return (
    <TableRow
      key={row.id}
      onClick={(e) => actions.onActivateRow(e, row.id)}
      selected={active}
      hover
    >
      <TableCell>
        <TableControls.ItemPicker
          value={row.land}
          onChange={(e, v) => actions.onChange(e, row.id, { land: v })}
          readOnly={fields.land.read_only || readOnly || !currentOrg}
          errors={errors && errors.land}
          backend={fields.land.resource}
        />
      </TableCell>
    </TableRow>
  );
}

Row.propTypes = {
  row: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    land: PropTypes.shape({ id: PropTypes.number, repr: PropTypes.string }),
  }).isRequired,
  fields: PropTypes.shape({
    land: PropTypes.shape({ read_only: PropTypes.bool, resource: PropTypes.string }),
  }).isRequired,
  actions: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onActivateRow: PropTypes.func.isRequired,
  }).isRequired,
  readOnly: PropTypes.bool,
  active: PropTypes.bool,
  errors: PropTypes.shape({ land: PropTypes.arrayOf(PropTypes.string) }),
  currentOrg: PropTypes.number,
};

Row.defaultProps = {
  readOnly: false,
  active: false,
  errors: null,
  currentOrg: null,
};

export default memo(Row);
